import { render, staticRenderFns } from "./studentList.vue?vue&type=template&id=9e9d7ff0&"
import script from "./studentList.vue?vue&type=script&lang=js&"
export * from "./studentList.vue?vue&type=script&lang=js&"
import style0 from "./studentList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "studentList.vue"
export default component.exports